import { render, staticRenderFns } from "./BizStartupService.vue?vue&type=template&id=073aab26&scoped=true"
import script from "./BizStartupService.vue?vue&type=script&lang=js"
export * from "./BizStartupService.vue?vue&type=script&lang=js"
import style0 from "./BizStartupService.vue?vue&type=style&index=0&id=073aab26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073aab26",
  null
  
)

export default component.exports